<template>
  <span></span>
</template>

<script>
function draw() {
  if (!window._connector)
    return;

  const { canvas, nodes } = window._connector;
  canvas.width = document.body.scrollWidth * window.devicePixelRatio;
  canvas.height = document.body.scrollHeight * window.devicePixelRatio;
  const ctx = canvas.getContext('2d');
  ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  for (const [ fromId, toId ] of Object.values(nodes)) {
    const from = document.getElementById(fromId);
    const to = document.getElementById(toId);
    if (from && to) {
      const rFrom = from.getBoundingClientRect();
      const rTo = to.getBoundingClientRect();
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#1976d2';
      ctx.beginPath();
      ctx.moveTo(window.scrollX + rFrom.x + rFrom.width / 2, window.scrollY + rFrom.y + rFrom.height / 2);
      ctx.lineTo(window.scrollX + rTo.x + rTo.width / 2, window.scrollY + rTo.y + rTo.height / 2);
      ctx.stroke();
    }
  }

  window._connector.timeout = setTimeout(() => requestAnimationFrame(draw), 1);
}


function register(id, from, to, zIndex) {
  if (!window._connector) {
    const c = document.createElement('canvas');
    c.style['pointer-events'] = 'none';
    c.style['position'] = 'absolute';
    c.style['width'] = '100%';
    c.style['height'] = '100%';
    c.style['z-index'] = String(zIndex);
    document.getElementsByClassName('v-application')[0].appendChild(c);
    window._connector = { canvas: c, nodes: [] };
    draw();
  }
  window._connector.nodes[id] = [ from, to ];
}


function deregister(id) {
  delete window._connector.nodes[id];
  if (!Object.values(window._connector.nodes).length) {
    clearTimeout(window._connector.timeout);
    window._connector.canvas.remove();
    delete window._connector;
  }
}


export default {
  name: 'connector',

  props: {
    from: String,
    to: String,
    zIndex: { type: Number, default: 203 }
  },

  computed: {
    update() {
      return [ this.from, this.to ];
    }
  },

  created() {
    register(this._uid, this.from, this.to, this.zIndex);
  },

  destroyed() {
    deregister(this._uid);
  },

  watch: {
    update(v) {
      window._connector.nodes[ this._uid ] = v;
    },

    zIndex(v) {
      window._connector.canvas.style['z-index'] = String(v);
    }
  }
}
</script>
